import { useMutation } from '@tanstack/react-query'

import { updateReservationBuyerInfo } from '../request/reservationApis'

import type { IReservation } from '../../model'

const useUpdateReservationBuyerInfoMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (reservation: IReservation) => void
  onError?: (error: Error) => void
}) => {
  return useMutation({
    mutationFn: updateReservationBuyerInfo,
    onSuccess,
    onError,
    throwOnError: false,
  })
}

export default useUpdateReservationBuyerInfoMutation
